import React from 'react';

export interface ImagenIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ImagenIcon: React.FC<ImagenIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.334 21.662h14a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2h-14a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2m0 0 11-11 5 5m-11-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
    </svg>
  );
};

export default ImagenIcon;
